import { Body1, Button } from '@fluentui/react-components';
import { InfoRegular, OpenRegular } from '@fluentui/react-icons';
import { CardNote } from './_shared.js';
import { useStyles } from './_styles.js';

type OnlineFormProps = {
    url: string;
    accent: string;
    tenantName: string;
};

export function OnlineForm({ url, accent, tenantName }: OnlineFormProps) {
    const styles = useStyles();

    return (
        <>
            <Body1 className={styles.lead}>
                Wir sorgen dafür, dass Sie sich schnell wieder auf die schönen Dinge des Lebens konzentrieren können.
            </Body1>

            {/* A real link rather than window.open: anchors survive popup
                suppression in the embedding contexts (task pane, portal iframe)
                far more reliably. */}
            <Button
                as="a"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                appearance="primary"
                className={styles.cta}
                style={{ backgroundColor: accent }}
                icon={<OpenRegular />}
                iconPosition="after"
            >
                Schaden online melden
            </Button>

            <CardNote icon={<InfoRegular />}>Öffnet das Online-Formular von {tenantName} in einem neuen Tab.</CardNote>
        </>
    );
}
